export function redirect (type, data) {
  switch (type) {
    case 5:
    case 6:
    case 8:
      if (data.hostedUrl) {
        window.location.href = data.hostedUrl
      }
      break
  }
}



// WEBPACK FOOTER //
// ./src/util/order-redirect.js